'use client'

import Image from 'next/image'
import NextLink from 'next/link'
import { VideosSlider } from '@/components/pages/videos/index'
import { IProduct } from '@/entities'
import { useState } from 'react'
import { useTranslations } from 'next-intl'
import ModalVideo from 'react-modal-video'
import { extractYoutubeVideoId } from '@/utils'

type TProps = {
  product: IProduct
}

const VideosProductContainer = ({product}: TProps) => {
  const t = useTranslations("pages.videos")

  const [isVideoPlayerModalShown, setIsVideoPlayerModalShown] = useState(false);
  const [videoId, setVideoId] = useState<string>('');

  const handleOpenVideoPlayer = (url: string) => {
    const youtubeVideoId = extractYoutubeVideoId(url)

    if (youtubeVideoId) {
      setVideoId(youtubeVideoId);
      setIsVideoPlayerModalShown(true);
    }
  }

  return (
    <>
      <div className="col-md-9 col-xxl-10 content">
        <div className="left-side">
          <h1 className="product-title">
            {product.title}
          </h1>
          <div className="img-box position-relative">
            <Image
              className="object-fit-contain h-auto"
              src={product.cover}
              alt={product.title}
              width={500}
              height={500}
              quality={100}
            />
          </div>
          <div className="more-details">
            <NextLink
              href={`/products/${product.alias}`}
              className="white-btn d-inline-flex transparent"
            >
              {t('link')}
            </NextLink>
          </div>
        </div>

        <VideosSlider
          videos={product.videos || []}
          openVideoPlayer={(url) => handleOpenVideoPlayer(url)}
        />
      </div>

      <ModalVideo
        channel='youtube'
        youtube={{autoplay: 1}}
        isOpen={isVideoPlayerModalShown}
        videoId={videoId}
        onClose={() => setIsVideoPlayerModalShown(false)}
      />
    </>
  )
}

export default VideosProductContainer